import { PageHeader, Section } from "@/components/site/PageChrome";
import Footer from "@/components/site/Footer";
import {
  Store,
  Gift,
  TrendingUp,
  Star,
  ArrowRight,
} from "lucide-react";

export default function ShopPreRegistrationPage() {
  return (
    <>
      <PageHeader
        eyebrow="Business Registration"
        title="Shop Pre-Registration"
        subtitle="Reserve your business before the official launch and become one of our founding business partners."
      />

      <Section>

        {/* Hero */}

        <div className="rounded-[32px] bg-gradient-to-r from-[#FF5A00] to-[#FF8A3D] p-12 text-center text-white shadow-xl">

          <span className="inline-block rounded-full bg-white/20 px-4 py-2 text-sm font-semibold">
            🚀 Limited Launch Registration
          </span>

          <h2 className="mt-6 text-4xl font-bold">
            Grow Your Business with Time2Cash
          </h2>

          <p className="mt-4 max-w-3xl mx-auto text-lg text-white/90">
            Pre-register your business today and enjoy exclusive launch benefits
            designed for our first registered shops.
          </p>

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdKUTIVdeXKvQtYez0kKqwtJzFfpzHsJ6N6FaRN9KFRtsNlOA/viewform?usp=header"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 text-lg font-bold text-[#FF5A00] shadow-2xl animate-pulse hover:scale-105 transition"
          >
            Pre-Register Now
            <ArrowRight size={20} />
          </a>

        </div>

        {/* Benefits */}

        <div className="mt-20">

          <h2 className="text-3xl font-bold text-center">
            Why Register Early?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mt-10">

            <div className="rounded-3xl border p-6 bg-white">
              <Gift className="text-[#FF5A00]" size={36}/>
              <h3 className="mt-4 font-bold text-lg">
                Reserve Your Business Slot
              </h3>
              <p className="mt-2 text-gray-600">
                Secure your place before launch and become one of our founding
                business partners.
              </p>
            </div>

            <div className="rounded-3xl border p-6 bg-white">
              <TrendingUp className="text-[#FF5A00]" size={36}/>
              <h3 className="mt-4 font-bold text-lg">
                Priority Business Listing
              </h3>
              <p className="mt-2 text-gray-600">
                Early registered shops receive better visibility during the
                launch phase.
              </p>
            </div>

            <div className="rounded-3xl border p-6 bg-white">
              <Star className="text-[#FF5A00]" size={36}/>
              <h3 className="mt-4 font-bold text-lg">
                Up to 50% OFF Future Plans
              </h3>
              <p className="mt-2 text-gray-600">
                Eligible businesses can receive exclusive launch discounts on
                future subscription plans.
              </p>
            </div>

            <div className="rounded-3xl border p-6 bg-white">
              <Store className="text-[#FF5A00]" size={36}/>
              <h3 className="mt-4 font-bold text-lg">
                More Business Opportunities
              </h3>
              <p className="mt-2 text-gray-600">
                Get early customer enquiries, build reviews faster and get a
                chance to be featured on our official social media.
              </p>
            </div>

          </div>

        </div>

        {/* CTA */}

        <div className="mt-20 rounded-[32px] bg-[#FFF7F2] border border-[#FFD5B8] p-12 text-center">

          <h2 className="text-3xl font-bold">
            Ready to Join Time2Cash?
          </h2>

          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Complete your registration through our official Google Form.
            Registration takes only a few minutes.
          </p>

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdKUTIVdeXKvQtYez0kKqwtJzFfpzHsJ6N6FaRN9KFRtsNlOA/viewform?usp=header"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#FF5A00] px-8 py-4 text-lg font-bold text-white shadow-xl hover:bg-[#E65100] hover:scale-105 transition"
          >
            Open Registration Form
            <ArrowRight size={20}/>
          </a>

        </div>

        {/* Website */}

        <div className="mt-20 rounded-[32px] bg-[#1A1918] p-10 text-center text-white">

          <h2 className="text-3xl font-bold">
            Visit Time2Cash
          </h2>

          <p className="mt-3 text-white/80">
            Explore all features including Jobs, Marketplace, Shops, Local
            Services and much more.
          </p>

          <a
            href="/"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#FF5A00] px-8 py-4 font-bold hover:bg-[#E65100] transition"
          >
            Go to Home
            <ArrowRight size={18}/>
          </a>

        </div>

      </Section>
    </>
  );
}